import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useSignOut from 'react-auth-kit/hooks/useSignOut';

const Logout = () => {
  const navigate = useNavigate();
  const signOut = useSignOut();

  useEffect(() => {
    signOut();           // perform the sign out
    navigate('/login');  // redirect to login
  }, [signOut, navigate]);

  return null;

  
};

export default Logout;
